import {useSelector} from 'react-redux';

import {useAbortableLoad} from "../../Hooks";
import "./style.css";
import RepoBody from '../../Components/ReportBody/ReportBody.jsx'
import ContentContainer from "../../Components/ContentContainer/ContentContainer.js";

import mapStateToProps from './mapStateToProps.js'
import {getCriteria} from "../../shared/helpers/getCriteria";

const Reports = () => {

    const {
        selectedGeoObjArray = [],
        dateRangeCriteria,
        rangeStartDate,
        rangeEndDate
    } = useSelector(mapStateToProps)

    const criteria = getCriteria(
        dateRangeCriteria,
        rangeStartDate,
        rangeEndDate
    )

    const workingTimeSheet = useAbortableLoad(
        'getWorkingTimeSheet',
        'workingTimeSheet',
        {
            objIds: selectedGeoObjArray,
            criteria
        },
        selectedGeoObjArray?.length,
        [selectedGeoObjArray, dateRangeCriteria, rangeStartDate, rangeEndDate],
        'setWorkingTimeSheet'
    )

    return (
        <ContentContainer
            content={(
                <RepoBody data={workingTimeSheet?.data} loaderInfoSource={workingTimeSheet} />
            )}
        />

    )
}

export default Reports
